import React, { useEffect } from "react";

import { Card, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, Stack, Toolbar } from '@material-ui/core';
import AppPage from "../../components/AppFrame/AppPage";
import { RouteComponentProps } from "@reach/router";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import { useQueryParams, StringParam, withDefault } from "use-query-params";
import { actions } from '../../services/reportedUsers';
import CustomGrid from "../../components/CustomGrid";
import { UserReport } from "../../types";
import ReportedUserItem from "./ReportedUserItem";



const ReportedUsers: React.FC<RouteComponentProps> = () => {
  const dispatch = useDispatch();
  const state = useSelector((state: RootState) => state.reportedUsers);


  const [ filters, setFilters ] = useQueryParams({
    status: withDefault(StringParam, 'all'),
    reason: withDefault(StringParam, 'all'),
  });

  const handleFilterChange = (event: SelectChangeEvent<string>) => {
    setFilters({
      [ event.target.name ]: event.target.value
    }, 'replaceIn');
  };

  useEffect(() => {
    dispatch(actions.loadList(filters as any, false));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ filters ]);

  const loadMore = () => {
    console.log('loading more reported users...');
    dispatch(actions.loadList(filters as any, true));
  }

  return (
    <AppPage title="Reported Users">
      <Card variant="outlined" sx={{ width: '100%', padding: '10px 0px' }}>
        <Toolbar>
          <Stack direction="row" spacing={2}>
            <FormControl sx={{ minWidth: 120 }}>
              <InputLabel id="source-label">Status</InputLabel>
              <Select
                name="status"
                labelId="status-label"
                value={filters.status}
                label="Status"
                onChange={handleFilterChange}
              >
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="pending">Pending</MenuItem>
                <MenuItem value="resolved">Resolved</MenuItem>
              </Select>
            </FormControl>

            <FormControl sx={{ minWidth: 120 }}>
              <InputLabel id="reason-label">Reason</InputLabel>
              <Select
                name="reason"
                labelId="reason-label"
                value={filters.reason}
                label="Reason"
                onChange={handleFilterChange}
              >
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="inappropriate_photos">Inappropriate photos</MenuItem>
                <MenuItem value="inappropriate_messages">Inappropriate messages</MenuItem>
                <MenuItem value="feels_like_spam">Feels like spam</MenuItem>
                <MenuItem value="paid_services">Paid services</MenuItem>
                <MenuItem value="other">Other</MenuItem>


              </Select>
            </FormControl>
          </Stack>
        </Toolbar>
      </Card>

      <CustomGrid
        id="reported-users"
        onLoadMore={loadMore}
        items={state.list}
        itemWidth={280}
        itemHeight={480}
        spacing={10}
        isLoadingMore={state.loadingMore}
        // alignToCenter
        onRenderItem={(report: UserReport) => {
          return <ReportedUserItem data={report} />
        }}
      />
    </AppPage>
  );
};

export default ReportedUsers;